"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _delegates = require("../../actions/delegates.actions");
var _delegateModal = _interopRequireDefault(require("../delegates/delegateModal.component"));
var _CustomForm = _interopRequireDefault(require("./CustomForm"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _DialogContentText = _interopRequireDefault(require("@mui/material/DialogContentText"));
var _getResource = require("../../utilities/getResource");
var _CustomRadioGroup = _interopRequireDefault(require("./CustomRadioGroup"));
var _ErrorOutline = _interopRequireDefault(require("@mui/icons-material/ErrorOutline"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto'
    },
    stepper: {
      padding: '1rem',
      backgroundColor: '#eceded' //SilverSand['100']
    },
    actionsWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: '5rem'
    },
    button: {},
    dialogIcon: {
      position: 'relative',
      top: theme.spacing(0.5),
      paddingRight: 5
    }
  };
};
var CustomTabs = /*#__PURE__*/function (_Component) {
  function CustomTabs(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomTabs);
    _this = _callSuper(this, CustomTabs, [props]);
    (0, _defineProperty2["default"])(_this, "handleChangeTab", function (event, activeTab) {
      if (!_this.state.hasError) {
        _this.setState({
          activeTab: activeTab
        });
      } else {
        _this.setState({
          showAlert: true,
          gotoTab: activeTab
        });
      }
    });
    _this.state = {
      open: false,
      pageId: null,
      questions: [],
      tab: {},
      tabs: [],
      techQuestionsPage: false,
      activeTab: 0,
      showAlert: false,
      hasError: false,
      errorMessage: '',
      gotoTab: 0,
      showCompleteModal: false,
      showCompleteModalSelection: false
    };
    ['handleSubmit', 'handleSaveChanges', 'handleNextTab', 'handlePreviousTab', 'goToTab', 'handleNextPage', 'handlePreviousPage', 'handleDelegateModalClose', 'handleResendDelegate', 'handleRemoveDelegate', 'handleSendDelegates', 'handleCloseAlert', 'handleOkAlert', 'showAlert', 'handleNextPageCompleteModal', 'changeCompleteModal', 'sendUserHome', 'handleNextPageCustom', 'hideCompleteModal'].map(function (name) {
      return _this[name] = _this[name].bind(_this);
    });
    _this.form = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  (0, _inherits2["default"])(CustomTabs, _Component);
  return (0, _createClass2["default"])(CustomTabs, [{
    key: "handleNextTab",
    value: function () {
      var _handleNextTab = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this2 = this;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //need to force a save here before we unmount from this current form so we make sure the save is successful before navigating away
              console.log('handleNextTab....', this.state.hasError, this.props.isApiError, this.props.onChangeTab, this.state.activeTab);
              if (!this.state.hasError && !this.props.isApiError) {
                window.scrollTo(0, 0);
                this.setState({
                  activeTab: this.state.activeTab + 1
                }, function () {
                  console.log('calling onChangeTab....', _this2.state.hasError, _this2.props.isApiError, _this2.props.onChangeTab, _this2.state.activeTab);
                  if (_this2.props.onChangeTab) _this2.props.onChangeTab(_this2.state.activeTab);
                });
              } else if (!this.props.isApiError) {
                this.setState({
                  showAlert: true,
                  gotoTab: this.state.activeTab - 1
                });
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleNextTab() {
        return _handleNextTab.apply(this, arguments);
      }
      return handleNextTab;
    }()
  }, {
    key: "handlePreviousTab",
    value: function () {
      var _handlePreviousTab = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this3 = this;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log('handlePreviousTab....', this.state.hasError, this.props.isApiError);
              if (!this.state.hasError && !this.props.isApiError) {
                window.scrollTo(0, 0);
                this.setState({
                  activeTab: this.state.activeTab - 1
                }, function () {
                  console.log('calling handlePreviousTab....', _this3.state.hasError, _this3.props.isApiError, _this3.props.onChangeTab, _this3.state.activeTab);
                  if (_this3.props.onChangeTab) _this3.props.onChangeTab(_this3.state.activeTab);
                });
              } else if (!this.props.isApiError) {
                this.setState({
                  showAlert: true,
                  gotoTab: this.state.activeTab - 1
                });
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handlePreviousTab() {
        return _handlePreviousTab.apply(this, arguments);
      }
      return handlePreviousTab;
    }()
  }, {
    key: "goToTab",
    value: function () {
      var _goToTab = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(tab) {
        var _this4 = this;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.state.hasError && !this.props.isApiError) {
                this.setState({
                  activeTab: tab
                }, function () {
                  if (_this4.props.onChangeTab) _this4.props.onChangeTab(tab);
                });
              } else if (!this.props.isApiError) {
                this.setState({
                  showAlert: true,
                  gotoTab: tab
                });
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function goToTab(_x) {
        return _goToTab.apply(this, arguments);
      }
      return goToTab;
    }()
  }, {
    key: "handleNextPage",
    value: function handleNextPage() {
      window.scrollTo(0, 0);
      this.props.handleNextPage(this.props.match.params.pageId, this.props.entity);
    }
  }, {
    key: "handleNextPageCompleteModal",
    value: function () {
      var _handleNextPageCompleteModal = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              console.log('HANDLING COMPLETE MODAL', this.props);
              if (!this.props.isApiError && (this.props.page.pageProgress === undefined || this.props.page.pageProgress.completed === false)) {
                this.setState({
                  showCompleteModal: true
                });
              } else if (!this.props.isApiError) {
                console.log('HANDLING NEXT PAGE');
                this.handleNextPage();
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleNextPageCompleteModal() {
        return _handleNextPageCompleteModal.apply(this, arguments);
      }
      return handleNextPageCompleteModal;
    }()
  }, {
    key: "hideCompleteModal",
    value: function hideCompleteModal() {
      this.setState({
        showCompleteModal: false
      });
      this.setState({
        showCompleteModalSelection: false
      });
    }
  }, {
    key: "changeCompleteModal",
    value: function changeCompleteModal(event, value) {
      console.log('CHANGING', value);
      var boolValue = false;
      if (value == 'true') {
        boolValue = true;
      }
      this.setState({
        showCompleteModalSelection: boolValue
      });
    }
  }, {
    key: "sendUserHome",
    value: function () {
      var _sendUserHome = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(e) {
        var _this5 = this;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              console.log('SENDING USER HOME', this.props);

              //console.log('this.props.page.pageId: ', this.props.page.pageId);
              //console.log('this.props.survey: ', this.props.survey);
              //console.log('this.props.entity.entityID: ', this.props.entity.entityID);

              if (this.state.showCompleteModalSelection) {
                this.props.completePage(this.props.page, this.form.state.changes).then(function () {
                  _this5.props.history.replace('/surveyLanding/' + _this5.props.survey.surveyGuid + '/home');
                });
              } else {
                this.props.history.replace('/surveyLanding/' + this.props.survey.surveyGuid + '/home');
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function sendUserHome(_x2) {
        return _sendUserHome.apply(this, arguments);
      }
      return sendUserHome;
    }()
  }, {
    key: "handleNextPageCustom",
    value: function () {
      var _handleNextPageCustom = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(e) {
        var _this6 = this;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (this.state.showCompleteModalSelection) {
                this.props.completePage(this.props.page, this.form.state.changes).then(function () {
                  _this6.handleNextPage();
                });
              } else {
                this.handleNextPage();
              }
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleNextPageCustom(_x3) {
        return _handleNextPageCustom.apply(this, arguments);
      }
      return handleNextPageCustom;
    }()
  }, {
    key: "handlePreviousPage",
    value: function () {
      var _handlePreviousPage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.props.isApiError) {
                window.scrollTo(0, 0);
                this.props.handlePreviousPage(this.props.match.params.pageId, this.props.entity);
              }
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handlePreviousPage() {
        return _handlePreviousPage.apply(this, arguments);
      }
      return handlePreviousPage;
    }()
  }, {
    key: "showAlert",
    value: function showAlert(errorMessage) {
      this.setState({
        hasError: errorMessage !== '',
        errorMessage: errorMessage
      });
    }
  }, {
    key: "handleOkAlert",
    value: function handleOkAlert() {
      window.scrollTo(0, 0);
      this.setState({
        showAlert: false,
        activeTab: this.state.gotoTab,
        hasError: false
      });
      if (this.props.onChangeTab) this.props.onChangeTab(this.state.gotoTab);
    }
  }, {
    key: "handleCloseAlert",
    value: function handleCloseAlert() {
      this.setState({
        showAlert: false
      });
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(data) {
        var newData, id;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              newData = _objectSpread(_objectSpread({}, this.props.entity.data), data);
              id = this.props.match.params.id;
              if ('surveyId' in this.props.match.params) {
                id = this.props.match.params.surveyId;
              }
              console.log('Saving survey changes from CustomTabs.js handleSubmit', id, this.props.entity.entityID);
              _context8.next = 1;
              return this.props.saveSurvey(id, this.props.entity.entityID, newData);
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function handleSubmit(_x4) {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }, {
    key: "handleSaveChanges",
    value: function () {
      var _handleSaveChanges = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(changes) {
        var id;
        return _regenerator["default"].wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              id = this.props.match.params.id;
              if ('surveyId' in this.props.match.params) {
                id = this.props.match.params.surveyId;
              }
              console.log('Saving survey changes from CustomTabs.js handleSaveChanges', id, this.props.entity.entityID);
              _context9.next = 1;
              return this.props.saveSurveyChanges(id, this.props.entity.entityID, changes);
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleSaveChanges(_x5) {
        return _handleSaveChanges.apply(this, arguments);
      }
      return handleSaveChanges;
    }()
  }, {
    key: "handleDelegateModalClose",
    value: function handleDelegateModalClose() {
      this.setState({
        open: false,
        tab: {}
      });
    }
  }, {
    key: "handleSendDelegates",
    value: function handleSendDelegates(newDelegates, sendPlainText) {
      var _this$state = this.state,
        entity = _this$state.entity,
        page = _this$state.page;
      var _this$props = this.props,
        addDelegate = _this$props.addDelegate,
        survey = _this$props.survey,
        delegates = _this$props.delegates,
        setDelegates = _this$props.setDelegates;
      console.log('in handleSendDelegates in CustomTabs.js, sendPlainText: ', sendPlainText);
      var delegatesClone = (0, _lodash.cloneDeep)(delegates);
      newDelegates.forEach(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0(d, index) {
          var response, entityIndex, tabIndex;
          return _regenerator["default"].wrap(function (_context0) {
            while (1) switch (_context0.prev = _context0.next) {
              case 0:
                _context0.next = 1;
                return addDelegate(survey.surveyID, d, sendPlainText);
              case 1:
                response = _context0.sent;
                if (!(response.type === 'ADD_DELEGATE_SUCCESS')) {
                  _context0.next = 2;
                  break;
                }
                if (!(0, _lodash.isEmpty)(delegatesClone.entities)) {
                  entityIndex = (0, _lodash.findIndex)(delegatesClone.entities, {
                    entityID: d.entityID
                  });
                  tabIndex = (0, _lodash.findIndex)(delegatesClone.entities[entityIndex].categories, {
                    pageID: d.pageID,
                    tabID: d.tabID
                  });
                  if (entityIndex !== -1 && tabIndex !== -1) {
                    delegatesClone.entities[entityIndex].categories[tabIndex].users.push(d);
                  } else if (entityIndex !== -1 && tabIndex === -1) {
                    delegatesClone.entities[entityIndex].categories = [{
                      pageID: d.pageID,
                      tabID: d.tabID,
                      users: [d]
                    }];
                  } else {
                    delegatesClone.entities = [{
                      entityID: d.entityID,
                      users: [],
                      categories: [{
                        pageID: d.pageID,
                        tabID: d.tabID,
                        users: [d]
                      }]
                    }];
                  }
                } else {
                  delegatesClone.entities = [{
                    entityID: entity.entityID,
                    users: [],
                    categories: [{
                      pageID: d.pageID,
                      tabID: d.tabID,
                      users: [d]
                    }]
                  }];
                }
                if (!(index + 1 === newDelegates.length)) {
                  _context0.next = 2;
                  break;
                }
                _context0.next = 2;
                return setDelegates(delegatesClone);
              case 2:
              case "end":
                return _context0.stop();
            }
          }, _callee0);
        }));
        return function (_x6, _x7) {
          return _ref.apply(this, arguments);
        };
      }());
      this.setState({
        open: false,
        tab: {}
      });
    }
  }, {
    key: "handleRemoveDelegate",
    value: function () {
      var _handleRemoveDelegate = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1(delegate) {
        var _this$props2, survey, removeDelegate, delegates, setDelegates, delegatesClone, response, userIndex, entityIndex, pageIndex, _userIndex, _entityIndex, _userIndex2;
        return _regenerator["default"].wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _this$props2 = this.props, survey = _this$props2.survey, removeDelegate = _this$props2.removeDelegate, delegates = _this$props2.delegates, setDelegates = _this$props2.setDelegates;
              delegatesClone = (0, _lodash.cloneDeep)(delegates);
              delete delegate.accessDelegates;
              _context1.next = 1;
              return removeDelegate(survey.surveyID, delegate);
            case 1:
              response = _context1.sent;
              if (!(response.type === 'REMOVE_DELEGATE_SUCCESS')) {
                _context1.next = 4;
                break;
              }
              if ((0, _lodash.hasIn)(delegate, 'entityID')) {
                _context1.next = 3;
                break;
              }
              userIndex = (0, _lodash.findIndex)(delegates.users, {
                email: delegate.email
              });
              delegatesClone.users.splice(userIndex, 1);
              _context1.next = 2;
              return setDelegates(delegatesClone);
            case 2:
              _context1.next = 4;
              break;
            case 3:
              if ('pageID' in delegate && 'tabID' in delegate) {
                entityIndex = (0, _lodash.findIndex)(delegatesClone.entities, {
                  entityID: delegate.entityID
                });
                pageIndex = (0, _lodash.findIndex)(delegatesClone.entities[entityIndex].categories, {
                  pageID: delegate.pageID,
                  tabID: delegate.tabID
                });
                _userIndex = (0, _lodash.findIndex)(delegatesClone.entities[entityIndex].categories[pageIndex].users, {
                  email: delegate.email
                });
                delegatesClone.entities[entityIndex].categories[pageIndex].users.splice(_userIndex, 1);
              } else if ('entityID' in delegate) {
                _entityIndex = (0, _lodash.findIndex)(delegatesClone.entities, {
                  entityID: delegate.entityID
                });
                _userIndex2 = (0, _lodash.findIndex)(delegatesClone.entities[_entityIndex].users, {
                  email: delegate.email
                });
                delegatesClone.entities[_entityIndex].users.splice(_userIndex2, 1);
              }
            case 4:
              _context1.next = 5;
              return setDelegates(delegatesClone);
            case 5:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function handleRemoveDelegate(_x8) {
        return _handleRemoveDelegate.apply(this, arguments);
      }
      return handleRemoveDelegate;
    }()
  }, {
    key: "handleResendDelegate",
    value: function () {
      var _handleResendDelegate = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(delegate, delegateModalDelegates, delegateModalSurvey, plainText) {
        var _this$props3, survey, resendDelegate, response;
        return _regenerator["default"].wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this$props3 = this.props, survey = _this$props3.survey, resendDelegate = _this$props3.resendDelegate;
              console.log('in handleResendDelegate in CustomTabs.js, sendPlainText: ', plainText);
              delete delegate.accessDelegates;
              _context10.next = 1;
              return resendDelegate(survey.surveyID, delegate, plainText);
            case 1:
              response = _context10.sent;
              if (response.type === 'RESEND_DELEGATE_SUCCESS') {
                console.log('CustomTabs, DELEGATE RESEND SUCCESS');
                this.setState({
                  showSubmitDialog: true
                });
              }
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handleResendDelegate(_x9, _x0, _x1, _x10) {
        return _handleResendDelegate.apply(this, arguments);
      }
      return handleResendDelegate;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props4 = this.props,
        answers = _this$props4.answers,
        auth = _this$props4.auth,
        classes = _this$props4.classes,
        countriesList = _this$props4.countriesList,
        delegates = _this$props4.delegates,
        entity = _this$props4.entity,
        inline = _this$props4.inline,
        page = _this$props4.page,
        productsList = _this$props4.productsList,
        regionsList = _this$props4.regionsList,
        showDelegates = _this$props4.showDelegates,
        survey = _this$props4.survey,
        surveyType = _this$props4.surveyType,
        tabs = _this$props4.tabs,
        technologiesList = _this$props4.technologiesList,
        vendorsList = _this$props4.vendorsList,
        regions = _this$props4.regions,
        resources = _this$props4.resources,
        pageQuestionCount = _this$props4.pageQuestionCount,
        pageId = _this$props4.pageId;
      var _this$state2 = this.state,
        activeTab = _this$state2.activeTab,
        techQuestionsPage = _this$state2.techQuestionsPage,
        questions = _this$state2.questions,
        tab = _this$state2.tab,
        countryQuestion = _this$state2.countryQuestion;
      var currentPageIndex = (0, _lodash.findIndex)(pageQuestionCount, function (p) {
        return p.pageId == pageId;
      });
      var previousPageIndex = currentPageIndex - 1;
      var questionNumberStart = 1;
      for (var x = previousPageIndex; x >= 0; x--) {
        questionNumberStart += pageQuestionCount[x].totalQuestions;
      }
      if (inline) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.root
        }, tabs && tabs.map(function (tab, idx) {
          if (idx > 0) {
            for (var _x11 = idx - 1; _x11 >= 0; _x11--) {
              if (pageQuestionCount[currentPageIndex] && pageQuestionCount[currentPageIndex].tabQuestionCount[tabs[_x11].tabId]) {
                questionNumberStart += pageQuestionCount[currentPageIndex].tabQuestionCount[tabs[_x11].tabId].count;
              }
            }
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: tab.tabId
          }, surveyType.scoringType !== 'DHIShort' &&
          /*#__PURE__*/
          //Don't show tab names if DHIShort
          _react["default"].createElement(_material.Grid, {
            container: true,
            justifyContent: "space-between"
          }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
            item: true,
            xs: 6
          }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
            variant: "h6"
          }, tab.tabName))), /*#__PURE__*/_react["default"].createElement(_CustomForm["default"], {
            answers: answers,
            countriesList: countriesList,
            entity: entity,
            onError: function onError(errors) {
              return console.log(errors);
            },
            onSubmit: _this7.handleSubmit,
            onSaveChanges: _this7.handleSaveChanges,
            productsList: productsList,
            questions: questions,
            regionsList: regionsList,
            surveyTemplate: surveyType.surveyTemplate,
            tabId: tab.tabId,
            techQuestionsForm: techQuestionsPage,
            technologiesList: technologiesList,
            vendorsList: vendorsList,
            regions: regions,
            surveyID: survey.surveyID,
            language: survey.language,
            resources: resources,
            scoringType: surveyType.scoringType,
            countryQuestion: countryQuestion,
            questionNumberStart: questionNumberStart,
            allQuestions: techQuestionsPage ? survey.technologyQuestions : survey.questions,
            wrappedComponentRef: function wrappedComponentRef(ref) {
              return _this7.form = ref;
            },
            isApiError: _this7.props.isApiError,
            isBlankAssessment: survey.createBlankSurvey
          }));
        }), showDelegates && /*#__PURE__*/_react["default"].createElement(_delegateModal["default"], {
          auth: auth,
          delegates: delegates,
          entity: entity,
          handleClose: this.handleDelegateModalClose,
          handleRemove: this.handleRemoveDelegate,
          handleResend: this.handleResendDelegate,
          handleSend: this.handleSendDelegates,
          open: this.state.open,
          page: page,
          survey: survey,
          tab: tab,
          language: survey.language,
          resources: resources
        }));
      } else {
        if (activeTab > 0) {
          for (var _x12 = activeTab - 1; _x12 >= 0; _x12--) {
            if (pageQuestionCount[currentPageIndex].tabQuestionCount[tabs[_x12].tabId]) {
              questionNumberStart += pageQuestionCount[currentPageIndex].tabQuestionCount[tabs[_x12].tabId].count;
            }
          }
        }
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
          open: this.state.showAlert,
          onClose: this.handleCloseAlert,
          "aria-labelledby": "form-dialog-title"
        }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
          id: "form-dialog-title"
        }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
          variant: "headline"
        }, /*#__PURE__*/_react["default"].createElement(_ErrorOutline["default"], {
          className: classes.dialogIcon,
          color: "error"
        }), "Warning")), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_DialogContentText["default"], {
          id: "alert-dialog-description"
        }, this.state.errorMessage)), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
          onClick: this.handleOkAlert,
          color: "primary"
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Ok')), /*#__PURE__*/_react["default"].createElement(_material.Button, {
          onClick: this.handleCloseAlert,
          color: "primary",
          autoFocus: true
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Cancel')))), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
          open: this.state.showCompleteModal,
          "aria-labelledby": "form-dialog-title"
        }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
          id: "form-dialog-title"
        }, " ", (0, _getResource.getResource)(resources, survey.language, 'Label', 'Would you like to mark this section as complete?'), " "), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, (process.env.REACT_APP_AUTH0_CALLBACK.indexOf('surveybuilder') > -1 || process.env.REACT_APP_AUTH0_CALLBACK.indexOf('localhost') > -1) && this.state.showCompleteModalSelection && /*#__PURE__*/_react["default"].createElement(_DialogContentText["default"], {
          color: 'red',
          paddingBottom: 1
        }, "WARNING: If changes have been made in this tab, please close this dialog, click on another tab to save the changes, then continue to the next section."), /*#__PURE__*/_react["default"].createElement(_CustomRadioGroup["default"], {
          name: 'showCompleteModalSelection'
          /*className={classes.radioGroup}*/,
          value: this.state.showCompleteModalSelection,
          direction: 'horizontal',
          onChange: this.changeCompleteModal
          /*previousValue={this.getValue(this.state.prevData, [...parents, question.questionID])}*/,
          answers: [{
            label: (0, _getResource.getResource)(resources, survey.language, 'Label', 'No'),
            value: false
          }, {
            label: (0, _getResource.getResource)(resources, survey.language, 'Label', 'Yes'),
            value: true
          }],
          hideClearButton: true
          /*resources={resources}
                  language={language}*/
        })), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
          onClick: this.sendUserHome,
          color: "primary"
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Home')), /*#__PURE__*/_react["default"].createElement(_material.Button, {
          onClick: this.handleNextPageCustom,
          color: "primary",
          autoFocus: true
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'NEXT SECTION')), (process.env.REACT_APP_AUTH0_CALLBACK.indexOf('surveybuilder') > -1 || process.env.REACT_APP_AUTH0_CALLBACK.indexOf('localhost') > -1) && this.state.showCompleteModalSelection && /*#__PURE__*/_react["default"].createElement(_material.Button, {
          onClick: this.hideCompleteModal,
          color: "primary"
        }, "Close"))), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.root
        }, /*#__PURE__*/_react["default"].createElement(_material.AppBar, {
          position: "static",
          color: "default"
        }, this.props.isInternal ? /*#__PURE__*/_react["default"].createElement(_material.Tabs, {
          value: activeTab,
          onChange: this.handleChangeTab,
          variant: tabs && tabs.length > 2 ? 'scrollable' : 'standard',
          scrollButtons: "auto"
        }, tabs && tabs.map(function (tab) {
          return /*#__PURE__*/_react["default"].createElement(_material.Tab, {
            key: tab.tabId,
            label: tab.tabName
          });
        })) : /*#__PURE__*/_react["default"].createElement(_material.Stepper, {
          nonLinear: true,
          alternativeLabel: tabs.length > 8 ? true : false,
          activeStep: activeTab,
          className: classes.stepper
        }, tabs && tabs.map(function (tab, index) {
          return /*#__PURE__*/_react["default"].createElement(_material.Step, {
            key: tab.tabId
          }, /*#__PURE__*/_react["default"].createElement(_material.StepButton, {
            onClick: function onClick() {
              return _this7.goToTab(index);
            }
          }, tab.tabName));
        }))), tabs && tabs.length > 0 && /*#__PURE__*/_react["default"].createElement(_CustomForm["default"], {
          key: tabs[activeTab].tabId,
          tabId: tabs[activeTab].tabId,
          entity: entity,
          techQuestionsForm: techQuestionsPage,
          questions: questions,
          answers: answers,
          onSubmit: this.handleSubmit,
          onSaveChanges: this.handleSaveChanges,
          onError: function onError(errors) {
            return console.log(errors);
          },
          countriesList: countriesList,
          regionsList: regionsList,
          productsList: productsList,
          technologiesList: technologiesList,
          vendorsList: vendorsList,
          regions: regions,
          showAlert: this.showAlert,
          surveyID: survey.surveyID,
          language: survey.language,
          resources: resources,
          scoringType: surveyType.scoringType,
          countryQuestion: countryQuestion,
          questionNumberStart: questionNumberStart,
          allQuestions: techQuestionsPage ? survey.technologyQuestions : survey.questions,
          wrappedComponentRef: function wrappedComponentRef(ref) {
            return _this7.form = ref;
          },
          isApiError: this.props.isApiError,
          isBlankAssessment: survey.createBlankSurvey
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.actionsWrapper
        }, activeTab === 0 ? /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          variant: "contained",
          onClick: this.handlePreviousPage,
          disabled: this.props.isFirstPage()
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Previous Section')) : /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          variant: "contained",
          onClick: this.handlePreviousTab
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Previous')), /*#__PURE__*/_react["default"].createElement("div", null, activeTab === tabs.length - 1 ? /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          variant: "contained",
          onClick: this.handleNextPageCompleteModal,
          disabled: this.props.isLastPage()
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Next Section')) : /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          variant: "contained",
          onClick: this.handleNextTab
        }, (0, _getResource.getResource)(resources, survey.language, 'Label', 'Next'))))));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var newState = _objectSpread({}, state);
      console.log('CustomTabs.js getDerivedStateFromProps');
      // If the page has changed, reset the state data.
      var techQuestionsPage = typeof props.pageId === 'string' && props.pageId.startsWith('tq_');
      if (techQuestionsPage && props.technologyQuestions.length > 0) {
        newState = {
          techQuestionsPage: techQuestionsPage,
          questions: props.technologyQuestions
        };
      } else if (props.questions.length && !techQuestionsPage) {
        newState = {
          techQuestionsPage: techQuestionsPage,
          questions: props.questions
        };
      }
      if (state.pageId !== props.pageId) {
        newState['activeTab'] = props.activeTab ? props.activeTab : 0;
      }
      newState['pageId'] = props.pageId;
      //}
      var countryQuestion = (0, _lodash.find)(props.survey.questions, {
        controlType: 'Address'
      });
      if (!countryQuestion) countryQuestion = (0, _lodash.find)(props.survey.questions, {
        mappingGroupAttribute: '116'
      });
      newState['countryQuestion'] = countryQuestion;
      return newState;
    }
  }]);
}(_react.Component);
CustomTabs.propTypes = {
  inline: _propTypes["default"].bool,
  isInternal: _propTypes["default"].bool.isRequired,
  isFirstPage: _propTypes["default"].func,
  isLastPage: _propTypes["default"].func,
  handlePreviousPage: _propTypes["default"].func,
  handleNextPage: _propTypes["default"].func,
  completePage: _propTypes["default"].func,
  entity: _propTypes["default"].object.isRequired,
  questions: _propTypes["default"].array.isRequired,
  surveyType: _propTypes["default"].object.isRequired,
  pages: _propTypes["default"].array.isRequired,
  tabs: _propTypes["default"].array.isRequired,
  answers: _propTypes["default"].array.isRequired,
  saveSurvey: _propTypes["default"].func.isRequired,
  saveSurveyChanges: _propTypes["default"].func,
  technologiesList: _propTypes["default"].array.isRequired,
  productsList: _propTypes["default"].array,
  regionsList: _propTypes["default"].array,
  vendorsList: _propTypes["default"].array,
  countriesList: _propTypes["default"].array,
  entityHospitals: _propTypes["default"].array,
  entityAmbulatories: _propTypes["default"].array,
  entitySubAcutes: _propTypes["default"].array,
  entityHomeHealths: _propTypes["default"].array,
  entityFreeStandingDataCenters: _propTypes["default"].array,
  entityInHospitalDataCenters: _propTypes["default"].array,
  entityUntetheredAmbulatories: _propTypes["default"].array,
  showDelegates: _propTypes["default"].bool,
  auth: _propTypes["default"].object,
  delegates: _propTypes["default"].object,
  page: _propTypes["default"].object,
  survey: _propTypes["default"].object,
  regions: _propTypes["default"].array
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {};
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
  addDelegate: _delegates.addDelegate,
  removeDelegate: _delegates.removeDelegate,
  resendDelegate: _delegates.resendDelegate,
  setDelegates: _delegates.setDelegates
})((0, _reactRouter.withRouter)(CustomTabs)));